import { Box } from "@mui/material";
import { Fragment } from "react";
import { toast } from "react-toastify";
import { inputFieldArray } from "./data";

export const notifyFormSucess = () =>
  toast.success("Form Created Successfully", {
    toastId: "form-creation",
  });

export const notifyUpdateSuccess = () =>
  toast.success("Form Updated Successfully", {
    toastId: "form-creation",
  });

export const notifyAllDeleteSucess = () =>
  toast.success("All Fields Deleted Successfully", {
    toastId: "delete-creation",
  });

export const notifyError = (msg) =>
  toast.error(`${msg ? msg : "Something went wrong !"}`, {
    toastId: "delete-creation",
  });

export const renamePanelToolboxItem = (creator) => {
  // Wait for toolbox to initialize
  setTimeout(() => {
    // Method 1: Direct toolbox item modification
    const panelItem = creator.toolbox.items.find(
      (item) => item.json && item.json.type === "panel",
    );

    if (panelItem) {
      // Direct title change (most reliable)
      panelItem.title = "Two Row Column";

      // Also update locTitle for localization
      if (panelItem.locTitle) {
        panelItem.locTitle.text = "Two Row Column";
      }

      // Update JSON template
      panelItem.json = {
        ...panelItem.json,
        title: "Two Row Column",
        name: "twoRowColumn",
      };
    }
  }, 200); // Delay to ensure toolbox is loaded
};

export const renamePanelInPropertyGrid = (creator) => {
  // When panel is selected, update its title in property grid
  creator.onSelectedElementChanged.add((sender, options) => {
    if (options.newElement && options.newElement.getType() === "panel") {
      // Check if it has the default name/title
      const element = options.newElement;
      if (element.title === "panel" || element.title === "Panel") {
        element.title = "Two Row Column";
      }
      if (element.name === "panel" || element.name.includes("panel")) {
        element.name = "twoRowColumn" + Date.now().toString().slice(-4);
      }
    }
  });
};

export function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Fragment>{children}</Fragment>
        </Box>
      )}
    </div>
  );
}

// export function transformSurveyJson(inputJson, questionnaireId) {
//   const result = [];
//   let index = 0;

//   const fullJsonString = JSON.stringify(inputJson);

//   (inputJson.pages || []).forEach((page) => {
//     const title = page.title;
//     const uid = page.uid;
//     const pageQ = page.questionnaireJson || {};

//     /* ========= CREATE PAGE OBJECT (FULL SCHEMA + EXTRA PAGE FIELDS) ========= */
//     const pageBase = createBaseObject({
//       questionnaireId,
//       index,
//       fullJsonString,
//       q: pageQ,
//       el: page,
//       isPage: true,
//       title,
//       uid,
//     });

//     // ➕ Add page-specific extras
//     pageBase.page_Id = page.uid || page.id || crypto.randomUUID();
//     pageBase.page_Number = pageQ.number || "";
//     pageBase.page_Name = page.name || "";
//     pageBase.page_FooterText = pageQ.footerText || "";
//     pageBase.page_IsHandwritingEnabled = pageQ.isHandwritingEnabled === "true";
//     pageBase.page_IsScrollForMoreEnabled = pageQ.isScrollEnabled === "true";
//     pageBase.page_TranslationKey = pageQ.translationKey || page.uid || "";

//     result.push(pageBase);
//     index++;

//     /* ========= CREATE QUESTION OBJECTS ========= */
//     (page.elements || []).forEach((el) => {
//       const q = el.questionnaireJson || {};

//       const baseObj = createBaseObject({
//         questionnaireId,
//         index,
//         fullJsonString,
//         q,
//         el,
//         isPage: false,
//         title,
//         uid,
//       });

//       result.push(baseObj);
//       index++;
//     });
//   });

//   return result;
// }

function flattenElements(elements = [], acc = [], ctx = {}) {
  elements.forEach((el) => {
    acc.push(
      createBaseObject({
        ...ctx,
        index: ctx.counter.value,
        el,
        isPage: false,
      }),
    );
    ctx.counter.value++;

    if (Array.isArray(el.elements)) {
      flattenElements(el.elements, acc, ctx);
    }
  });
}

export function transformSurveyJson(inputJson, questionnaireId) {
  const result = [];
  // let index = 0;
  const counter = { value: 0 };
  const fullJsonString = JSON.stringify(inputJson);

  (inputJson.pages || []).forEach((page) => {
    const title = page.title;
    const uid = page.uid;
    const pageQ = page.questionnaireJson || {};

    // Page object
    const pageBase = createBaseObject({
      questionnaireId,
      // index,
      index: counter.value,
      fullJsonString,
      q: pageQ,
      el: page,
      isPage: true,
      title,
      uid,
    });

    pageBase.page_Id = page.uid || page.id || crypto.randomUUID();
    result.push(pageBase);
    // index++;
    counter.value++;

    // 🔁 Recursive flatten
    flattenElements(page.elements || [], result, {
      questionnaireId,
      // index,
      counter,
      fullJsonString,
      title,
      uid,
    });
  });

  return result;
}

/* ========== BASE SCHEMA BUILDER ========== */
function createBaseObject({
  questionnaireId,
  index,
  fullJsonString,
  q,
  el,
  isPage,
  title,
  uid,
}) {
  console.log("Q got", el);
  const inputFieldIdData = inputFieldArray?.find(
    (item) =>
      item?.questionType === el?.type || item?.questionType === el?.inputType,
  );

  console.log("inputFieldIdData", inputFieldIdData);

  return {
    // ===== System =====
    isFieldSet: isPage ? true : false,
    questionnaireId,
    isDirty: true,
    syncVersion: 0,

    // ===== Core =====
    questionDisplayText: title || "",
    questionTranslationKey: el?.uid || "",
    description: q?.description || "",
    sequence: Number(q?.sequenceNumber || 0),
    diaryPageId: q?.selectedDiaryPage || "",
    groupNumber: Number(q?.groupNumber || 0),

    // ===== Values =====
    minValue: q?.minValueTextKeyText || "",
    maxValue: q?.maxValueDisplayText || "",
    minValueDisplayText: q?.minValueTextKeyText || "",
    maxValueDisplayText: q?.maxValueDisplayText || "",
    summaryDisplayText: q?.summaryDisplayText || "",
    minValueTextKey: q?.minValueTextKeyText || "",
    maxValueTextKey: q?.maxValueDisplayText || "",

    // ===== UI =====
    displayAlignment: q?.selectedDisplayProperty || "",
    textAlignment: "",
    choiceOrientation: "",
    autoResizeChoices: q?.autoResizeChoice || false,
    width: 0,
    marginTop: 0,
    marginLeft: 0,
    marginBottom: 0,
    marginRight: 0,
    textSize: 0,
    columnCount: 0,
    paddingCharacters: "",
    paddingLocation: 0,

    // ===== Flags =====
    isActive: q?.active !== "false",
    isRequired: q?.validateQuestionnaire === "true" || false,
    isInstruction: q?.isInstruction === "true",
    displayOnConfirmation: q?.displayOnConfirmation === "true",
    isLandscapeOrientation: q?.landScapeOrientation === "true",
    isSticky: false,

    // ===== Business =====
    visibleBusinessRuleId: q?.selectedBusinessRule || "",
    enabledBusinessRuleId: q?.selectedEnabledQuestionnaire || "",

    // ===== Export =====
    exportDisplayOrder: Number(q?.exportDisplayOrder || 0),
    exportDisplayName: q?.exportDisplayName || "",
    summaryDisplayTextKey: el?.uid,

    // ===== IDs =====
    // dataPointId: "",
    externalId: el?.uid || "",
    patientAttributeConfigurationDetailId: q?.selectedPatientAttribute || "",
    submitActionParameterId: q?.selectedSubmitAction || "",
    choiceDisplayTypeId: "",

    // ===== Types =====
    inputFieldTypeId: inputFieldIdData
      ? Number(inputFieldIdData?.inputFieldId)
      : 1,
    questionTypeId: Number((q?.selectedQuestionType || "").split(".")[0] || 1),

    // ===== System Ordering =====
    orderValue: index + 1,

    // ===== JSON Storage Rule =====
    json: fullJsonString,

    // ===== Marker =====
    // isPageContainer: isPage,
  };
}

// export function buildUpdatePayloadFromSurveyJson(
//   oldSurveyJson,
//   newSurveyJson,
//   questionnaireId,
// ) {
//   // Step 1: transform both into flat arrays
//   const oldFlat = transformSurveyJson(oldSurveyJson, questionnaireId);
//   const newFlat = transformSurveyJson(newSurveyJson, questionnaireId);

//   // Step 2: diff them
//   return diffRecords(oldFlat, newFlat);
// }

// function diffRecords(oldArr = [], newArr = []) {
//   const result = [];

//   const oldMap = new Map();
//   const newMap = new Map();

//   oldArr.forEach((obj) => {
//     if (obj.externalId) oldMap.set(obj.externalId, obj);
//   });

//   newArr.forEach((obj) => {
//     if (obj.externalId) newMap.set(obj.externalId, obj);
//   });

//   /* ========= NEW + UPDATED ========= */
//   newArr.forEach((newObj) => {
//     const id = newObj.externalId;
//     const oldObj = oldMap.get(id);

//     if (!oldObj) {
//       // ➕ New
//       result.push({
//         ...newObj,
//         isANewRecord: true,
//         markRecordAsUpdated: false,
//         markRecordAsDeleted: false,
//       });
//     } else {
//       // ✏️ Existing
//       result.push({
//         ...newObj,
//         isANewRecord: false,
//         markRecordAsUpdated: true,
//         markRecordAsDeleted: false,
//       });
//     }
//   });

//   /* ========= DELETED ========= */
//   oldArr.forEach((oldObj) => {
//     const id = oldObj.externalId;

//     if (!newMap.has(id)) {
//       result.push({
//         ...oldObj,
//         isANewRecord: false,
//         markRecordAsUpdated: false,
//         markRecordAsDeleted: true,
//       });
//     }
//   });

//   return result;
// }

export function buildUpdatePayloadFromSurveyJson(
  oldSurveyJson,
  newSurveyJson,
  questionnaireId,
  loadData = [], // 👈 DB data (existing records)
) {
  // 1) Flatten both survey JSONs
  const oldFlat = transformSurveyJson(oldSurveyJson, questionnaireId);
  const newFlat = transformSurveyJson(newSurveyJson, questionnaireId);

  // 2) Build loadData map (externalId -> DB record)
  const loadMap = new Map();
  (loadData || []).forEach((rec) => {
    if (rec.externalId) {
      loadMap.set(rec.externalId, rec);
    }
  });

  // 3) Diff
  return diffRecordsWithLoadData(oldFlat, newFlat, loadMap);
}

function diffRecordsWithLoadData(oldArr = [], newArr = [], loadMap) {
  const result = [];

  const oldMap = new Map();
  const newMap = new Map();

  oldArr.forEach((obj) => {
    if (obj.externalId) oldMap.set(obj.externalId, obj);
  });

  newArr.forEach((obj) => {
    if (obj.externalId) newMap.set(obj.externalId, obj);
  });

  /* ========= NEW + UPDATED ========= */
  newArr.forEach((newObj) => {
    const extId = newObj.externalId;
    const oldObj = oldMap.get(extId);
    const loadObj = loadMap.get(extId); // 👈 DB record

    if (!oldObj) {
      // ➕ New record
      result.push({
        ...newObj,
        id: "00000000-0000-0000-0000-000000000000", // 👈 NEW RECORD
        questionTranslationKey: "00000000-0000-0000-0000-000000000000",
        page_TranslationKey: "00000000-0000-0000-0000-000000000000",
        isANewRecord: true,
        markRecordAsUpdated: false,
        markRecordAsDeleted: false,
      });
    } else {
      // ✏️ Existing record
      result.push({
        ...newObj,
        questionTranslationKey: loadObj?.id,
        page_TranslationKey: loadObj?.id,
        id: loadObj?.id || null, // 👈 reuse DB id
        isANewRecord: false,
        markRecordAsUpdated: true,
        markRecordAsDeleted: false,
      });
    }
  });

  /* ========= DELETED ========= */
  // oldArr.forEach((oldObj) => {
  //   const extId = oldObj.externalId;

  //   if (!newMap.has(extId)) {
  //     const loadObj = loadMap.get(extId);

  //     result.push({
  //       ...oldObj,
  //       id: loadObj?.id || null, // 👈 DB id for delete
  //       isANewRecord: false,
  //       questionTranslationKey: loadObj?.id,
  //       page_TranslationKey: loadObj?.id,
  //       markRecordAsUpdated: false,
  //       markRecordAsDeleted: true,
  //     });
  //   }
  // });
  oldArr.forEach((oldObj) => {
    const extId = oldObj.externalId;

    if (!newMap.has(extId)) {
      const loadObj = loadMap.get(extId);

      // ❌ If record never existed in DB, skip it
      if (!loadObj?.id) return;

      result.push({
        ...oldObj,
        id: loadObj.id,
        isANewRecord: false,
        questionTranslationKey: loadObj.id,
        page_TranslationKey: loadObj.id,
        markRecordAsUpdated: false,
        markRecordAsDeleted: true,
      });
    }
  });

  return result;
}

export function mapReceivedIds(json, loadData = []) {
  if (!json || !Array.isArray(loadData)) return json;

  // Build fast lookup map: externalId -> record
  const loadMap = new Map();
  loadData.forEach((rec) => {
    if (rec?.externalId) {
      loadMap.set(rec.externalId, rec);
    }
  });

  // Recursive walker
  function traverse(node) {
    if (!node || typeof node !== "object") return node;

    const cloned = { ...node };

    // Match uid with externalId
    if (node.uid && loadMap.has(node.uid)) {
      const matched = loadMap.get(node.uid);
      cloned.receivedId = matched.id; // 👈 attach DB id
    }

    // Recurse into elements
    if (Array.isArray(node.elements)) {
      cloned.elements = node.elements.map((child) => traverse(child));
    }

    return cloned;
  }

  return {
    ...json,
    pages: Array.isArray(json.pages)
      ? json.pages.map((page) => traverse(page))
      : [],
  };
}
